<script setup lang="ts">
import AiIcon from '@lahaus-roomie/roomie/src/assets/icons/v2/ai.svg'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'

const { t } = useI18n()

const handleCTAClick = () => {
  window.open('https://www.lahaus.ai', '_blank', 'noopener,noreferrer')
}
</script>

<script lang="ts">
export default {
  name: 'LaHausAIBanner'
}
</script>

<template>
  <div class="w-full pt-24 md:pt-36 pb-16 md:pb-24 bg-pine-600">
    <div class="mx-auto max-w-screen-xl px-24 xl:px-0">
      <div class="bg-[#173330] rounded-24 px-24 md:px-36 py-16 md:py-20">
        <div class="flex flex-col sm:flex-row items-center sm:items-center justify-between gap-16 sm:gap-24">
          <div class="flex items-center gap-16 flex-1">
            <div class="flex-shrink-0 text-lime-600">
              <AiIcon class="w-32 h-32" />
            </div>

            <p class="text-white body-2-m md:body-1-m">
              {{ t('title') }}
            </p>
          </div>

          <div class="w-full sm:w-auto flex justify-center">
            <RoomieButton
              variant="light"
              size="md"
              class="text-pine-800"
              @click="handleCTAClick">
              {{ t('cta') }}
            </RoomieButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n src="./i18n.json" lang="json"></i18n>
